export default "__VITE_ASSET__90418592__"